"use client";

import * as React from "react";
import { Area, AreaChart, CartesianGrid, XAxis } from "recharts";
import { TrendingUp, Trophy, Users, Activity } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const chartData = [{
  month: "Gen",
  performance: 220
}, {
  month: "Feb",
  performance: 280
}, {
  month: "Mar",
  performance: 350
}, {
  month: "Apr",
  performance: 410
}, {
  month: "Mag",
  performance: 520
}, {
  month: "Giu",
  performance: 650
}];
const chartConfig = {
  performance: {
    label: "Isolamento",
    color: "hsl(var(--primary))"
  }
} satisfies ChartConfig;
const rankingsData = [{
  rank: 1,
  name: "Isolamento Termico",
  points: 0.85,
  trend: "up"
}, {
  rank: 2,
  name: "Abbattimento Acustico",
  points: 45,
  trend: "stable"
}, {
  rank: 3,
  name: "Resistenza Aria/Acqua",
  points: 9,
  trend: "up"
}];
const carouselImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/tennis_action_serve.png",
  alt: "Dettaglio profilo in alluminio charcoal"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/tennis_community_handshake.png",
  alt: "Installazione serramento moderno"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/tennis_crowd_cheering.png",
  alt: "Vista panoramica con infissi minimali"
}];
export default function About() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}